import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-recruiters-popover',
  templateUrl: './recruiters-popover.component.html',
  styleUrls: ['./recruiters-popover.component.css']
})
export class RecruitersPopoverComponent {

  @Input() requisitionInfo;
  @Input() isCorporateCompany;
  @Input() vendorRecruitersNotAvailable;

  trackByIndex(index) {
    return index;
  }

}
